import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto, ExperienceListDto } from "@intelligems/ig-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";

interface RelatedExperienceActiveDialogProps {
  handleEnableToggle: (personalization: ExperienceListDto) => void;
}

export const RelatedExperienceActiveDialog = ({
  handleEnableToggle,
}: RelatedExperienceActiveDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("relatedExperienceActive"));
  const dialogProps = useSelector(
    getDialogPropDetails("relatedExperienceActive")
  );

  const handleClose = () => {
    dispatch(setDialog({ dialog: "relatedExperienceActive", open: false }));
  };

  const handleYesClick = () => {
    handleEnableToggle(dialogProps?.personalization);
    handleClose();
  };

  const contentText = (
    <IgTypography>
      The active test "{dialogProps?.isUsedInTestName}" is testing an experience
      that may be very similar to this Experience. To avoid unpredictable
      visitor experiences, check the test before activating this Experience.
      <br />
      <br />
      Are you sure you want to activate this Experience?
    </IgTypography>
  );

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      PaperProps={{
        sx: { padding: "10px" }, // Adds padding around the entire dialog
      }}
    >
      <DialogTitle sx={{ paddingBottom: 0 }}>Related Test Active</DialogTitle>
      <DialogContent sx={{ marginTop: "20px" }}>{contentText}</DialogContent>
      <DialogActions sx={{ borderTop: "none" }}>
        <IgButton onClick={handleClose}>Cancel</IgButton>
        <IgButton onClick={handleYesClick} variant="contained">
          Yes, activate it
        </IgButton>
      </DialogActions>
    </Dialog>
  );
};
